import React from 'react';
import { fetchArticleRelatedContent } from '../../../../apis/article.api';
import { useQuery } from '@tanstack/react-query';
import { profileAtom } from 'src/components/Settings/atom';
import { useAtom } from 'jotai';
import SmallWidgetArticleComponent from './components/small-widget-article.component';

const RelatedContentContainer = ({ articleId }) => {
  const [profile] = useAtom(profileAtom);

  const params = {
    limit: 9,
    page: 1
  };

  const { data: articles } = useQuery({
    queryKey: ['getRelatedContents', params],
    queryFn: () => fetchArticleRelatedContent(articleId, params)
  });

  return articles?.data?.length > 0 ? (
    <div className="px-10 md:px-40">
      <h1 className="font-[800] text-[24px] md:text-[32px] text-center mt-6 md:mt-[40px] mb-6 md:mb-[60px]">
        Related Articles
      </h1>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 md:gap-x-[48px] md:gap-y-[70px]">
        {articles?.data?.map((item) => (
          <SmallWidgetArticleComponent key={item?.id} article={item} profile={profile} />
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
};
export default RelatedContentContainer;
